import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["heightField"]

  connect() {
    console.log("Body measurement form controller connected")
  }

  async fetchLatestHeight(event) {
    const userId = event.detail.id
    if (!userId) return

    try {
      const response = await fetch(`/admin/body_measurements/latest_height?user_id=${userId}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) throw new Error('身長の取得に失敗しました')

      const data = await response.json()
      
      if (data.height && this.hasHeightFieldTarget) {
        this.heightFieldTarget.value = data.height
        // 身長が自動入力されたことを視覚的に示す
        this.heightFieldTarget.classList.add('bg-light')
        setTimeout(() => {
          this.heightFieldTarget.classList.remove('bg-light')
        }, 1000)
      }
    } catch (error) {
      console.error('Error fetching latest height:', error)
    }
  }
}